import { WebSocketState } from "./websocket.types";

export const webSocketGetters = {
  isConnected: (state: WebSocketState) => state.isConnected
};
  